import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import "./ProductList.css";

export default function ProductList() {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch("https://app.nkvairamaaligai.com/api/v1/admin/product/product-lists")
            .then((response) => response.json())
            .then((data) => {
                setProducts(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching products:", error);
                setLoading(false);
            });
    }, []);

    // Animation variants for Framer Motion
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2, // Stagger animations for child elements
            },
        },
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
        hover: {
            scale: 1.05,
            boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)",
            transition: { duration: 0.3 },
        },
    };

    const textVariants = {
        hidden: { opacity: 0, x: -20 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
    };

    const buttonVariants = {
        hover: {
            scale: 1.1,
            backgroundColor: "#0056b3",
            transition: { duration: 0.3 },
        },
    };

    return (
        
        <motion.section
            className="shop-container"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
        >
            <h3 style={{ color: 'black', fontWeight: '450px' }}> ProductList</h3>
            {loading ? (
                <div className="loading-spinner">
                    <Button variant="primary" disabled>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                        Loading...
                    </Button>
                </div>
            ) : (
                <motion.div
                    className="product-grid"
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                >
                    {products.length > 0 ? (
                        products.map((product) => (
                            <motion.div
                                key={product.id}
                                className="product-card"
                                variants={cardVariants}
                                whileHover="hover"
                                whileTap={{ scale: 0.95 }} // Add a tap effect
                            >
                                <motion.img
                                    src={`data:${product.productImage.imageType};base64,${product.productImage.imageByte}`}
                                    alt={product.productName}
                                    className="product-image1"
                                    whileHover={{ scale: 1.1 }}
                                    transition={{ duration: 0.3 }}
                                />
                                <motion.h3
                                    className="product-name"
                                    variants={textVariants}
                                >
                                    {product.productName}
                                </motion.h3>
                                <motion.div
                                    className="product-info"
                                    variants={textVariants}
                                >
                                    <p className="product-price">₹ {product.productPrice}</p>
                                    <p className="product-weight">{product.productWeight} grams</p>
                                </motion.div>
                                <motion.button
                                    className="buy-now-btn"
                                    variants={buttonVariants}
                                    whileHover="hover"
                                >
                                    Buy Now
                                </motion.button>
                            </motion.div>
                        ))
                    ) : (
                        <motion.p
                            className="no-products"
                            variants={textVariants}
                            initial="hidden"
                            animate="visible"
                        >
                            No products found
                        </motion.p>
                    )}
                </motion.div>
            )}
        </motion.section>
    );
}